import * as React from 'react';

const SvgComponent = (props) => (
  <svg
    id="Group_5452"
    data-name="Group 5452"
    xmlns="http://www.w3.org/2000/svg"
    width={81.694}
    height={22.74}
    {...props}>
    <defs>
      <linearGradient
        id="linear-gradient"
        x1={0.059}
        y1={0.066}
        x2={1}
        y2={1}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#e73636" />
        <stop offset={0.582} stopColor="#e92222" />
        <stop offset={1} stopColor="#bf0505" />
      </linearGradient>
      <style>{'.cls-3{fill:#ffe9e9}'}</style>
    </defs>
    <g
      id="Rectangle_2229"
      data-name="Rectangle 2229"
      style={{
        stroke: '#ee2828',
        fill: 'none'
      }}>
      <path
        d="M0 0h77.01a3 3 0 0 1 3 3v16.74a3 3 0 0 1-3 3H0V0Z"
        style={{
          stroke: 'none'
        }}
        transform="translate(1.685)"
      />
      <path
        d="M.5.5h76.51a2.5 2.5 0 0 1 2.5 2.5v16.74a2.5 2.5 0 0 1-2.5 2.5H.5V.5Z"
        style={{
          fill: 'none'
        }}
        transform="translate(1.685)"
      />
    </g>
    <path
      id="Rectangle_2228"
      data-name="Rectangle 2228"
      d="M3 0h19.74v22.74H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3Z"
      style={{
        fill: 'url(#linear-gradient)'
      }}
    />
    <g id="Group_5354" data-name="Group 5354" transform="translate(4.731 5.775)">
      <path
        id="Path_7586"
        data-name="Path 7586"
        className="cls-3"
        d="M8.128-3.59q1.147 0 1.147.974 0 .989-1.147.989H2.757q-1.162 0-1.162-.989 0-.974 1.162-.974h1.461v-6.424l-1.382.832a.909.909 0 0 1-.471.141.84.84 0 0 1-.665-.329 1.124 1.124 0 0 1-.275-.738.907.907 0 0 1 .487-.832l2.478-1.492a2.121 2.121 0 0 1 1.1-.33 1.163 1.163 0 0 1 .848.322 1.162 1.162 0 0 1 .33.872v7.978Z"
        transform="translate(-1.422 12.762)"
      />
      <path
        id="Path_7587"
        data-name="Path 7587"
        className="cls-3"
        d="M2.42-8.386a3.946 3.946 0 0 1-1.039-.131A2.17 2.17 0 0 1 .6-8.888a.5.5 0 0 1-.152-.166.48.48 0 0 1-.048-.223.478.478 0 0 1 .11-.311.319.319 0 0 1 .251-.134.477.477 0 0 1 .15.022.954.954 0 0 1 .18.088 2.38 2.38 0 0 0 .615.279 2.5 2.5 0 0 0 .686.088 1.349 1.349 0 0 0 .714-.155.5.5 0 0 0 .247-.445.4.4 0 0 0-.23-.353 2.952 2.952 0 0 0-.816-.254 4.522 4.522 0 0 1-1.05-.325 1.36 1.36 0 0 1-.573-.474 1.249 1.249 0 0 1-.18-.686 1.336 1.336 0 0 1 .258-.8 1.709 1.709 0 0 1 .714-.558 2.519 2.519 0 0 1 1.028-.2 2.628 2.628 0 0 1 1.654.5.561.561 0 0 1 .152.173.463.463 0 0 1 .046.216.478.478 0 0 1-.11.311.319.319 0 0 1-.246.134.479.479 0 0 1-.145-.021 1.007 1.007 0 0 1-.187-.092 2.972 2.972 0 0 0-.534-.276 1.774 1.774 0 0 0-.618-.092 1.2 1.2 0 0 0-.679.166.521.521 0 0 0-.247.456.41.41 0 0 0 .1.279.793.793 0 0 0 .31.195 4.859 4.859 0 0 0 .633.177 3.514 3.514 0 0 1 1.382.544 1.1 1.1 0 0 1 .421.912 1.326 1.326 0 0 1-.251.8 1.619 1.619 0 0 1-.707.537 2.719 2.719 0 0 1-1.058.19Zm4.4-.028a.547.547 0 0 1-.4-.148.528.528 0 0 1-.152-.4v-3.576h-1.14q-.523 0-.523-.452t.523-.445H8.52q.523 0 .523.445t-.523.452H7.375v3.576a.535.535 0 0 1-.148.4.544.544 0 0 1-.403.147Z"
        transform="translate(6.581 13.497)"
      />
    </g>
  </svg>
);

export default SvgComponent;
